import { ModalHeader } from '@components/App/Modal/components/ModalHeader'
import cx from 'classnames'
import type React from 'react'
import {
  type CSSProperties,
  type ReactNode,
  type UIEvent,
  useEffect,
  useState,
} from 'react'

import { useEscapeLayer } from '../../escape'
import { useClickOutside } from '../../hooks'
import css from './Panel.module.scss'

type Props = {
  title: ReactNode
  children: ReactNode
  additionalHeaderActions?: ReactNode
  containerClassName?: string
  copyUrl?: string
  showHeaderBorder?: boolean
  style?: CSSProperties
  renderMenu?: (closeDropdown: () => void) => ReactNode
  onClose: () => void
  onClickOptions?: () => void
  onOutsideClick?: () => void
}

export const Panel: React.FC<Props> = ({
  title,
  children,
  additionalHeaderActions,
  containerClassName,
  copyUrl,
  showHeaderBorder,
  style,
  renderMenu,
  onClose,
  onClickOptions,
  onOutsideClick,
}) => {
  const [showBorder, setShowBorder] = useState(false)

  const clickOutside = useClickOutside<HTMLDivElement>(
    Boolean(onOutsideClick),
    () => onOutsideClick?.()
  )

  useEffect(() => {
    if (showHeaderBorder !== undefined) {
      setShowBorder(showHeaderBorder)
    }
  }, [showHeaderBorder])

  useEscapeLayer(true, onClose)

  const handleContentScroll = (e: UIEvent<HTMLDivElement>) => {
    if (e.currentTarget.scrollTop >= 2) {
      setShowBorder(true)
    } else {
      setShowBorder(false)
    }
  }

  return (
    <div
      className={cx(css.container, containerClassName)}
      style={style}
      ref={clickOutside.ref}
      onClick={clickOutside.onClick}
    >
      <ModalHeader
        title={title}
        copyUrl={copyUrl}
        additionalHeaderActions={additionalHeaderActions}
        showBorder={showBorder}
        renderMenu={renderMenu}
        onClose={onClose}
        onClickOptions={onClickOptions}
      />

      <div className={css.content} onScroll={handleContentScroll}>
        {children}
      </div>
    </div>
  )
}
